import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import "./styles/welcome.css";
import "./styles/wizard.css";
import "./styles/eight.css";
import "./styles/slider.css";
import "./styles/radio.css";
import "./styles/select.css";
import "./styles/checkbox.css";
import "./styles/summary.css";

import { App } from "./App";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
